// A tela é da rota-pai (`../checkout.tsx`), que continua desenhada embaixo quando a gaveta de
// editar abre. Esta rota-índice existe só para `/app/checkout` ser um destino válido.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/checkout/')({ component: () => null });
